import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const formSchema = z.object({
  _id: z.string().optional(),
  name: z.string().min(3, 'Nome deve ter no mínimo 3 caracteres'),
  description: z
    .string()
    .min(10, 'Descrição deve ter no mínimo 10 caracteres')
    .max(500, 'Descrição deve ter no máximo 500 caracteres'),
  isSellersApp: z.boolean().optional(),
  isTeamsApp: z.boolean().optional(),
})

export type TrainingFormValues = z.infer<typeof formSchema>

export const initialData: TrainingFormValues = {
  name: '',
  description: '',
  isSellersApp: false,
  isTeamsApp: false,
}

interface UseTrainingFormProps {
  defaultValues?: TrainingFormValues
}

export default function useTrainingForm({
  defaultValues,
}: UseTrainingFormProps) {
  const form = useForm<TrainingFormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: defaultValues ?? initialData,
  })

  return {
    form,
  }
}
